<template>
  <CockpitDialog
    :title="title"
    left="170px"
    width="1600px"
    height="700px"
    top="174px"
    cardType="horizontal"
    @close="$emit('close')"
  >
    <div class="text-20px text-[#fff] text-center font-bold leading-24px">
      {{ departmentalNotificationDetail.title }}
    </div>
    <!-- <div class="text-20px text-[#fff] text-center font-bold leading-24px">
      以高度的政治责任感扎实做好“五一”期间疫情防控和安全稳定工作李希王伟中孟凡利出席会议
    </div> -->
    <div class="text-14px mt-10px mb-30px text-[#fff] text-center leading-17.78px">
      <span class="mr-100px"
        >作者：{{ JSON.parse(departmentalNotificationDetail.publisherNames)[0] }}</span
      >
      <span
        >发布时间：{{
          dayjs(departmentalNotificationDetail.publishTime).format('YYYY-MM-DD HH:mm:ss')
        }}</span
      >
    </div>
    <div
      class="text-16px text-[#fff] leading-24px mx-150px overflow-y-scroll h-30rem"
      v-html="departmentalNotificationDetail.content"
    >
      <!-- {{ departmentalNotificationDetail.content }} -->
      <!-- 4月28日，全省疫情防控和安全稳定工作电视电话会议在广州召开，同时套开省新冠肺炎防控领导小组（指挥部）会议，深入学习贯彻习近平总书记关于疫情防控和安全生产的重要指示精神，对做好“五一”期间疫情防控和安全稳定工作进行再部署再落实。省委书记李希出席会议并讲话，省委副书记、省长王伟中主持会议，省委副书记、深圳市委书记孟凡利出席会议。
      李希强调，要深入学习贯彻习近平总书记重要指示精神，切实扛起沉甸甸的政治责任，坚持以人民为中心的发展思想，坚持统筹发展和安全，坚持以大概率思维应对小概率事件，以高度的政治责任感扎实做好“五一”期间疫情防控和安全稳定工作。一要采取“快、严、实”的精准措施，迅速扑灭广州白云国际机场突发疫情。把握“黄金24小时”窗口期迅速果断处置，严格落实社区分级分类管控措施，做深做细流调排查，科学实施区域筛查，严防风险扩散，同时周密做好封控管控区群众正常生活和医疗服务保障，最大限度降低疫情对群众生活的影响。二要坚持从严从紧从细，全力以赴做好“五一”期间疫情防控工作。严格落实假期疫情防控措施，强化重点场所疫情防控，抓好旅途和景区防控管理，进一步加强联防联控、群防群控，周全做好节日期间生活物资保障工作，让群众过一个平安祥和的节日。把牢防线严防疫情输入，紧盯航空、陆路、水运口岸和人物同防“四个方向”，强化“外防输入”全流程闭环管理。落实“四早”措施，不断提升发热门诊、基层医疗卫生机构、药店等哨点敏锐性、敏感度，确保监测预警机制高效运转。三要采取有力措施补短板、强弱项、除隐患，确保社会大局平安稳定。抓严抓实安全生产工作，深入开展安全生产大检查，紧盯危化品、建筑施工、道路交通、水上交通、城镇燃气、消防、旅游设施、矿山、大型群众性活动等重点行业重点领域集中攻坚，加强路面执法和交通疏导，全面压实安全生产责任，严防安全生产事故发生。抓严抓实防汛防台风工作，密切监视雨情水情风情发展动态，加强汛情灾情分析研判，抓好隐患排查治理。强化政治安全和意识形态安全风险防范，强化社会治安管理，依法严厉打击违法犯罪，全力维护社会大局和谐稳定。四要加强领导、落实责任，以“时时放心不下”的责任感把疫情防控和安全稳定各项措施落细落实落到位。全省各级党委政府要强化属地管理，党政一把手要亲自上手亲自抓，切实担负起“促一方发展、保一方平安”的政治责任；各相关部门要抓好统筹协调、推动落实；广大基层党组织要发挥战斗堡垒作用，广大党员要发挥先锋模范作用，让党旗在疫情防控和安全稳定一线高高飘扬。要狠抓工作落实，加强值班值守和督促检查，以铁的肩膀、铁的作风、铁的执行把各项部署落到实处。
      会上，省委常委、政法委书记，常务副省长张虎通报全省疫情防控和安全稳定工作情况。
      会议以电视电话会议形式开至各地级以上市。省领导林克庆、张福海、陈建文、陈良贤、王曦、张新、王志忠，省直、中直驻粤有关单位主要负责同志，各地级以上市党政主要负责同志参加会议。 -->
    </div>
    <div class="text-14px text-[#fff] absolute bottom-30px leading-24px mx-150px">
      附件：<span class="ml-20px text-[#00BCC8] cursor-pointer" @click="openFile">{{
        fileList.name
      }}</span>
    </div>
  </CockpitDialog>
</template>

<script>
import { FileApi } from '@wiz-api/file-management'
import CockpitDialog from '@/components/cockpit/CockpitDialog'

const fileApi = new FileApi()
export default {
  components: {
    CockpitDialog,
  },
  props: {
    // 标题
    title: {
      type: String,
      default: '',
    },
    // 默认管道基础台账
    type: {
      type: String,
      default: 'pipelineFoundationLedger',
    },
    bimDetail: {
      type: Object,
      default: () => {},
    },
    departmentalNotificationDetail: {
      typeof: Object,
      default: () => {},
    },
  },
  data() {
    return {
      fileList: {},
    }
  },
  methods: {
    async getFile() {
      const params = this.departmentalNotificationDetail.attach
      const [err, res] = await fileApi.get(params)
      if (!err) {
        console.log(res, '文件')
        this.fileList = res
      }
    },
    // 打开文件
    async openFile() {
      const params = this.fileList.id
      const [err, res] = await fileApi.download(params, { returnType: 'Blob' })
      if (!err) {
        console.log(res, '文件')
        this.exportFile(res)
      }
    },
    // 下载文件
    exportFile(data) {
      const blob = new Blob([data], {
        type: 'application/pdf',
      })
      const blobUrl = window.URL.createObjectURL(blob)
      const templink = document.createElement('a')
      templink.style.display = 'none'
      templink.href = blobUrl
      templink.setAttribute('download', `${this.fileList.name}`)
      document.body.appendChild(templink)
      templink.click()
      document.body.removeChild(templink)
      window.URL.revokeObjectURL(blobUrl)
      this.$message({
        type: 'success',
        message: this.$t('下载成功!'),
      })
    },
  },
  mounted() {
    console.log(this.departmentalNotificationDetail, 'this.departmentalNotificationDetail')
    console.log(FileApi.Methods, 'FileApi')
    this.getFile()
  },
}
</script>

<style lang="scss" scoped></style>
